<div class="app__bg1"></div>
<div class="app__bg2"></div>

<div class="layout-visitor">
  <div class="layout-visitor__background"></div>
  <e-container
    [full]="true"
    class="layout-visitor__header-container">
    <div class="content">
      <a class="logo" routerLink="/">
        <img alt="Cosmose" class="logo__img" src="../../../../../assets/images/logo/cosmose.svg">
      </a>
      <e-language-selection class="language-selection"></e-language-selection>
    </div>
  </e-container>

  <div class="layout-visitor__content-container layout-content">
    <e-container>
      <router-outlet></router-outlet>
    </e-container>
  </div>
</div>

